<template>
    <div class="your-dates__date">
        <div class="your-dates__date-title">
            {{activity.date|moment('dddd')}}
            <strong>{{activity.date|moment('D. MMM YYYY')}}</strong>
        </div>
        <div class="your-dates__category">
            <span class="main-category-icon" :class="iconAndColorClass"></span> {{subcategoryName}}
        </div>
        <div v-if="activity.strength" class="your-dates__date-strength">
            <translate>Strength of your day</translate>:&nbsp;<day-strength :strength="activity.strength"></day-strength>
        </div>
    </div>
</template>
<script>
    import DayStrength from "../components/calendar/DayStrength"

    export default {
        name: 'activity-date-display',
        components: {DayStrength},
        props: {
            activity: {},
            iconClass: {},
            subcategoryName: {},
            color: {}
        }, computed: {
            colorClass: function () {
                if (this.color!=null) {
                    return 'objective-color__background-color--'+this.color
                }
                return ''
            },
            iconAndColorClass: function () {
                return this.iconClass + ' ' + this.colorClass
            },
        }
    }
</script>